<template>
  <transition name="fade">
    <div id="coins-agree" class="coins-agree" v-if="visible">
      <div class="coins-agree-shadow" @click="hideCoinsAgreePopup"></div>
      <div class="coins-agree-main">
        <a
          href="javascript:;"
          class="main-close"
          @click="hideCoinsAgreePopup"
        ></a>
        <div class="main-content">
          <h2 class="main-content-title">
            {{ letter.abountZbit.replace('\${Z-BIT}', getCoinsName) }}
          </h2>
          <div class="main-content-desc scroll">
            <p class="agree-text">
              {{ coinsIntro.replaceAll('Z-BIT', getCoinsName) }}
            </p>
            <a :href="serviceLink" class="agree-link" target="_blank">{{
              letter.fwtk
            }}</a>
          </div>
          <a href="javascript:;" class="agree-confirm" @click="confirm">{{
            letter.mywork_confirm
          }}</a>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import serviceLink from '@mixins/officialWebStore/serviceLink';

export default {
  name: 'CoinsAgreePopup',
  mixins: [serviceLink],
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      gameId: state => state.gameId,
      lang: state => state.lang
    }),
    ...mapGetters(['getCoinsName', 'gameInfoConfig']),
    defaultLang() {
      return this.gameInfoConfig?.defaultLang || '';
    },
    coinsIntro() {
      return (
        this.gameInfoConfig?.coinConfig?.coinsIntro?.[this.lang] ||
        this.gameInfoConfig?.coinConfig?.coinsIntro?.[this.defaultLang] ||
        ''
      );
    }
  },
  data() {
    return {
      boolAgree: false
    };
  },
  methods: {
    hideCoinsAgreePopup() {
      this.$emit('update:visible', false);
    },
    confirm() {
      this.hideCoinsAgreePopup();
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialWebStore/_dimen.scss';
.coins-agree {
  z-index: 20;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  &-shadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.4);
  }
  &-main {
    position: absolute;
    left: 50%;
    top: 50%;
    box-sizing: border-box;
    width: 708px;
    transform: translate(-50%, -50%);
    background: #fff;
    border-radius: 10px;
  }

  .main {
    &-close {
      position: absolute;
      right: 32px;
      top: 27px;
      background: url($tmslgImg + 'close.png') no-repeat;
      width: 28px;
      height: 28px;
      cursor: pointer;
    }
    &-content {
      &-title {
        font-size: 26px;
        text-align: center;
        line-height: 86px;
        height: 86px;
        border-radius: 10px 10px 0 0;
        margin: 0;
        @include g-popup-title();
      }
      &-desc {
        overflow: auto;
        height: 472px;
        margin: 20px 38px 20px;
        padding-right: 12px;
        font-size: 24px;
        font-weight: normal;
        line-height: 36px;
        text-align: left;
        color: #333;

        .agree-text {
          margin-bottom: 22px;
        }
        .agree-link {
          display: inline-block;
          padding-bottom: 3px;
          margin-left: 56px;
          border-bottom: 1px solid $btnBg;
          font-size: 24px;
          color: $btnBg;
        }
        .agree-item {
          color: $btnBg;
        }
      }
      .agree-confirm {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 244px;
        box-sizing: border-box;
        font-size: 24px;
        height: 80px;
        color: #fff;
        border-radius: 10px;
        padding: 0 10px;
        background: $btnBg;
        cursor: pointer;
        margin: 0 auto 20px;
      }
    }
  }
}
</style>
